import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarTipoNotificacaoDs } from "../../DataSources";
import HtmlEditor, { Toolbar, Item } from "devextreme-react/html-editor";
import ShowError from "../../AppServices";

let _notificacaoCorrente;

const template = {
  id: undefined,
  prefeituraId: undefined,
  codigo: "",
  titulo: "",
  texto: "",
};

export default class TipoNotificacaoForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.tipoNotificacao = criarTipoNotificacaoDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.notesOptions = { height: 140, border: true };
    this.sizeValues = ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"];
    this.fontValues = [
      "Arial",
      "Courier New",
      "Georgia",
      "Impact",
      "Lucida Console",
      "Tahoma",
      "Times New Roman",
      "Verdana",
    ];
    this.headerValues = [false, 1, 2, 3, 4, 5];
    this.enabled = {
      enabled: true,
    };
    this.valueChangedOnText = this.valueChangedOnText.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.tipoNotificacao
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Texto Cda não encontrado.", "error");
            this.props.history.push("/textoscda");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem caption="RECEITA" colSpan={2} colCount={2}>
              <SimpleItem dataField={"codigo"}>
                <Label text="Código" />
              </SimpleItem>
              <SimpleItem dataField={"titulo"}>
                <Label text="Título" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="TEXTO" colSpan={2} colCount={1}>
              <HtmlEditor
                height={"300px"}
                mediaResizing={this.enabled}
                value={this.state.texto}
                onValueChanged={this.valueChangedOnText}
              >
                <Toolbar>
                  <Item formatName="undo" />
                  <Item formatName="redo" />
                  <Item formatName="separator" />
                  <Item formatName="size" formatValues={this.sizeValues} />
                  <Item formatName="font" formatValues={this.fontValues} />
                  <Item formatName="separator" />
                  <Item formatName="bold" />
                  <Item formatName="italic" />
                  <Item formatName="strike" />
                  <Item formatName="underline" />
                  <Item formatName="separator" />
                  <Item formatName="alignLeft" />
                  <Item formatName="alignCenter" />
                  <Item formatName="alignRight" />
                  <Item formatName="alignJustify" />
                  <Item formatName="separator" />
                  <Item formatName="header" formatValues={this.headerValues} />
                  <Item formatName="separator" />
                  <Item formatName="orderedList" />
                  <Item formatName="bulletList" />
                  <Item formatName="separator" />
                  <Item formatName="color" />
                  <Item formatName="background" />
                  <Item formatName="separator" />
                  <Item formatName="link" />
                  <Item formatName="image" />
                  <Item formatName="separator" />
                  <Item formatName="clear" />
                  <Item formatName="codeBlock" />
                  <Item formatName="blockquote" />
                </Toolbar>
              </HtmlEditor>
            </GroupItem>
            <GroupItem colCount={6}>
              <ButtonItem
                horizontalAlignment={"left"}
                buttonOptions={{
                  type: "success",
                  text: "Salvar",
                  onClick: this.ok,
                }}
              />
              <ButtonItem
                horizontalAlignment={"left"}
                buttonOptions={{
                  type: "warn",
                  text: "Cancelar",
                  onClick: this.cancel,
                }}
              />
            </GroupItem>
          </Form>
        </div>
      </React.Fragment>
    );
  }

  valueChangedOnText(e) {
    this.setState({
      texto: e.value,
    });
  }

  ok() {
    const entidade = this.state;
    inserirOuAtualizar(this.tipoNotificacao, entidade)
      .then(
        function () {
          _notificacaoCorrente = undefined;
          notify("Tipo de Notificação cadastrada com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _notificacaoCorrente = undefined;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
